module.exports = __webpack_public_path__ + "static/primer-select-acce9b4f2734b169cad24ffa1ec90955.png";